<div id="mainDiv" class="login-page-wrapper">
    <!-- Ambient Lighting Backdrop Elements -->
    <div class="ambient-glow glow-top"></div>
    <div class="ambient-glow glow-bottom"></div>

    <!-- Login Container -->
    <div class="login-card-container">
        <div class="card login-card shadow-lg">
            <div class="card-body p-4 p-sm-5">
                <!-- Brand Header -->
                <div class="brand-header text-center mb-4">
                    <div class="logo-wrapper mb-3">
                        <img class="logo-img img-fluid" src="assets/aetherpsl-logo.png" alt="Aether HRMS">
                    </div>
                    <!-- <div class="enterprise-badge-pill mb-2">
                        <i class="fa-solid fa-shield-halved me-1 text-primary"></i>
                        <span>Enterprise HRMS Portal</span>
                    </div> -->
                    <h2 class="login-title">Sign in to your account</h2>
                    <p class="login-subtitle">Enter your credentials to access your organization workspace</p>
                </div>

                <!-- Login Form -->
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
                    <!-- Username / Email Field -->
                    <div class="form-group mb-3 text-start">
                        <label class="form-label input-label" for="userName">
                            Email or Mobile Number <span class="text-danger">*</span>
                        </label>
                        <div class="input-icon-group">
                            <span class="input-icon-addon">
                                <i class="fa-regular fa-envelope"></i>
                            </span>
                            <input class="form-control modern-input" type="text"
                                placeholder="name@aetherpsl.com or mobile" formControlName="userName" id="userName"
                                required autocomplete="username email" (keyup)="onKeypressEvent($event)">
                        </div>
                    </div>

                    <!-- Password Field -->
                    <div class="form-group mb-4 text-start">
                        <div class="label-row d-flex justify-content-between align-items-center mb-1">
                            <label class="form-label input-label mb-0" for="password">
                                Password <span class="text-danger">*</span>
                            </label>
                            <button type="button" class="btn btn-link resetpass-link p-0" (click)="openResetPassword()">
                                Forgot password?
                            </button>
                        </div>
                        <div class="input-icon-group">
                            <span class="input-icon-addon">
                                <i class="fa-solid fa-lock"></i>
                            </span>
                            <input [type]="show ? 'text' : 'password'" placeholder="Enter your password"
                                formControlName="password" id="password" class="form-control modern-input input-with-toggle"
                                required maxlength="100" autocomplete="current-password">
                            <button class="btn btn-password-toggle" type="button" (click)="showPassword()"
                                title="Toggle password visibility">
                                <i [class]="passwordState"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Submit Button -->
                    <div class="form-action mb-4">
                        <button type="submit" class="btn btn-primary btn-sign-in w-100">
                            <span>Sign In</span>
                            <i class="fa-solid fa-arrow-right ms-2"></i>
                        </button>
                    </div>

                    <!-- Security Notice -->
                    <!-- <div class="security-footer text-center">
                        <span class="security-text">
                            <i class="fa-solid fa-shield-check text-emerald me-1"></i>
                            Secure 256-bit SSL encrypted connection
                        </span>
                    </div> -->
                </form>
            </div>
        </div>

        <!-- System Version / Copyright Footer -->
        <div class="login-page-footer text-center mt-3">
            <p class="text-muted small mb-0">
                &copy; {{ currentYear }} Aether Enterprise Application LLP. All rights reserved.
            </p>
        </div>
    </div>
</div>

<!-- Modern Enterprise Reset Password Dialog Template -->
<ng-template #resetPassAlertContent let-resetPassModal>
    <div class="reset-pass-popup-content p-4">
        <div class="text-center mb-3">
            <div class="reset-icon-badge mb-2">
                <i class="fa-solid fa-key"></i>
            </div>
            <h5 class="fw-bold text-dark mb-1">Reset Your Password</h5>
            <p class="text-muted small mb-0">Enter your registered corporate email address and we'll dispatch reset instructions to your inbox.</p>
        </div>

        <form [formGroup]="resetPassword" (ngSubmit)="onResetPasswordSubmit(); resetPassModal.dismiss('Success')">
            <div class="mb-3 text-start">
                <label class="form-label input-label" for="emailId">Corporate Email <span class="text-danger">*</span></label>
                <div class="input-icon-group">
                    <span class="input-icon-addon">
                        <i class="fa-regular fa-envelope"></i>
                    </span>
                    <input class="form-control modern-input" id="emailId" name="emailId"
                        formControlName="emailId" placeholder="e.g. name@aetherpsl.com" required autocomplete="email" />
                </div>
            </div>

            <div class="d-flex justify-content-end gap-2 pt-3 border-top mt-4">
                <button type="button" class="btn btn-outline-secondary px-4 fw-semibold"
                    (click)="resetPassModal.dismiss('Cancel')">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary px-4 fw-semibold"
                    (click)="onResetPasswordSubmit(); resetPassModal.dismiss('Success')">
                    <i class="fa-solid fa-paper-plane me-1"></i> Send Instructions
                </button>
            </div>
        </form>
    </div>
</ng-template>